import Form from 'react-bootstrap/Form';

export default function InputField({
                                     name,
                                     label,
                                     type,
                                     step,
                                     inputmode,
                                     placeholder,
                                     error,
                                     fieldRef,
                                     asTextarea,
                                     maxLength
                                   }) {
  return (
    <Form.Group controlId={name} className="InputField">
      {label && <Form.Label className="small mb-1">{label}</Form.Label>}
      <Form.Control
        type={type || 'text'}
        placeholder={placeholder}
        ref={fieldRef}
        as={asTextarea ? "textarea" : undefined}
        rows={asTextarea ? 5 : undefined}
        maxLength={maxLength ? maxLength : 256}
        step={step || null}
        inputMode={inputmode || null}
      />
      <Form.Text className="text-danger">{error}</Form.Text>
    </Form.Group>
  );
}
